import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SettingsService } from './modules/admin/settings/services/settings.service';

@Injectable({
	providedIn: 'root',
})
export class SettingsResolver {
	#settingsService = inject(SettingsService);
	resolve(): Observable<any> {
		return this.#settingsService.load$();
	}
}
